import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000, // 30s timeout (Render free tier cold starts take ~30s)
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('av_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle errors globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only redirect on 401 for NON-auth routes
    // Auth routes (login/register) should show the error to the user, not redirect
    const url = err.config?.url || '';
    const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/google') || url.includes('/auth/me');

    if (err.response?.status === 401 && !isAuthRoute) {
      localStorage.removeItem('av_token');
      localStorage.removeItem('av_user');
      window.location.href = '/login';
    }

    // If no response at all (network error / backend down), add a clear message
    if (!err.response) {
      err.message = 'Cannot connect to server. Please check your internet connection or try again later.';
    }

    return Promise.reject(err);
  }
);

export default api;
